import { render, staticRenderFns } from "./expertgroup.vue?vue&type=template&id=91c061ee&scoped=true"
import script from "./expertgroup.vue?vue&type=script&lang=js"
export * from "./expertgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c061ee",
  null
  
)

export default component.exports